import React from 'react';

interface KeywordFormFields {
    name: string;
    regex_pattern: string;
    description: string;
    is_case_sensitive: boolean;
}

interface KeywordFormProps {
    editingKeyword: any;
    form: KeywordFormFields;
    onFormChange: (fields: KeywordFormFields) => void;
    onSubmit: (e: React.FormEvent) => void;
    onCancel: () => void;
}

const KeywordForm: React.FC<KeywordFormProps> = ({
    editingKeyword,
    form,
    onFormChange,
    onSubmit,
    onCancel
}) => {
    return (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mt-4 mx-6">
            <h3 className="text-lg font-medium text-gray-900 mb-4">
                {editingKeyword ? 'Keyword Düzenle' : 'Yeni Keyword Ekle'}
            </h3>
            <form onSubmit={onSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Keyword Adı
                        </label>
                        <input
                            type="text"
                            placeholder="Örn: Dava"
                            value={form.name}
                            onChange={(e) => onFormChange({ ...form, name: e.target.value })}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Aranacak Kelimeler
                        </label>
                        <input
                            type="text"
                            placeholder="Örn: dava, case, lawsuit (virgülle ayırın)"
                            value={form.regex_pattern}
                            onChange={(e) => onFormChange({ ...form, regex_pattern: e.target.value })}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                        <p className="text-xs text-gray-500 mt-1">
                            Aranacak kelimeleri virgülle ayırarak yazın
                        </p>
                    </div>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Açıklama
                    </label>
                    <textarea
                        placeholder="Bu keyword'ün ne için kullanıldığını açıklayın"
                        rows={2}
                        value={form.description}
                        onChange={(e) => onFormChange({ ...form, description: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                        <label className="flex items-center">
                            <input
                                type="checkbox"
                                className="mr-2"
                                checked={form.is_case_sensitive}
                                onChange={(e) => onFormChange({ ...form, is_case_sensitive: e.target.checked })}
                            />
                            <span className="text-sm text-gray-700">Büyük/küçük harf duyarlı</span>
                        </label>
                    </div>
                    <div className="flex space-x-2">
                        <button
                            type="button"
                            onClick={onCancel}
                            className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
                        >
                            İptal
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                        >
                            {editingKeyword ? 'Keyword Güncelle' : 'Keyword Ekle'}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default KeywordForm;
